import React from 'react';
import styled from 'styled-components';
import { ComponentSize } from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import Button, { ButtonType } from '../Button/button';
import Icon, { SvgSrc } from '../Icon/Icon';
import SpinnerLinear from '../Spinner/SpinnerLinear';
import { Typography } from '../Typography/Typography';

const DownloadContractError = styled.div`
  margin-top: 0.5em;
  text-align: center;
`;

interface Props {
  isDownloading: boolean;
  downloadError: string;
  onClick: () => void;
  buttonText: string;
  buttonMargin?: number;
  smallSize?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  buttonType: ButtonType;
}

const DownloadPdf = (props: Props) => (
  <div>
    <Button
      type={props.buttonType}
      onClick={props.onClick}
      mt={props.buttonMargin}
      smallSize={props.smallSize}
      disabled={props.disabled}
      fullWidth={props.fullWidth}
    >
      {props.isDownloading ? (
        <SpinnerLinear filled={props.buttonType !== ButtonType.Filled} />
      ) : (
        <div>
          <Icon
            src={SvgSrc.FileInvoice}
            size={ComponentSize.Small}
            mr={0.5}
            color={theme.colors.white}
          />
          {props.buttonText}
        </div>
      )}
    </Button>
    {props.downloadError && (
      <DownloadContractError>
        <Typography color={theme.colors.error} lineHeight={1.4} fontSize={0.7}>
          {props.downloadError}
        </Typography>
      </DownloadContractError>
    )}
  </div>
);

DownloadPdf.defaultProps = {
  buttonMargin: undefined,
  smallSize: false,
  fullWidth: false,
  disabled: false,
};

export default DownloadPdf;
